import styled from '@emotion/styled';
import React from 'react';
import './CustomBanner.css';
import Box from '@mui/material/Box';

interface CustomBannerProps {
  htmlString?: string;
}

const CustomBannerWrapper = styled('div')({
  maxWidth: 700,
  maxHeight: 200,
});

const CustomBanner: React.FC<CustomBannerProps> = ({ htmlString }) => {
  if (!htmlString) return null;
  return (
    <CustomBannerWrapper>
      <Box
        id="hd_bottom_img"
        className="custom-banner"
        sx={{ margin: 'auto' }}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    </CustomBannerWrapper>
  );
};

export default CustomBanner;
